export default __webpack_public_path__ + "static/polishop-4a30a3ad98c4a321a874ad0e6680530f.jpg";